import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { withRouter } from 'react-router';
import NavigationBar from '../components/navigation-bar/NavigationBar';
import ApiNotWorking from './not-found/ApiNotWorking';
import Auth from '../auth/auth';

class PageWrapper extends Component {
  /*
    This component serves as a wrapper for all the other pages. When the user enters a page,
    the page component will be rendered in the {this.props.children}.
  */

  render() {
    const {
      component,
      onEnter,
      requireLogin,
      history,
      logout,
      ...rest
    } = this.props;
    onEnter();
    if (requireLogin && !Auth.isLoggedIn()) {
      Auth.redirect(history, '/logg-inn');
      return null;
    }
    if (logout) {
      Auth.logout(history);
      return null;
    }
    if (Auth.apiIsWorking()) {
      return (
        <div>
          <NavigationBar />
          <Container bsPrefix="container grid-container">
            {React.createElement(component, rest)}
          </Container>
        </div>
      );
    }
    return (
      <div>
        <NavigationBar />
        <Container>
          <ApiNotWorking />
        </Container>
      </div>
    );
  }
}

PageWrapper.defaultProps = {
  onEnter: () => {},
  requireLogin: false,
  component: () => null,
  logout: false
};

PageWrapper.propTypes = {
  component: PropTypes.func,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  onEnter: PropTypes.func,
  requireLogin: PropTypes.bool,
  logout: PropTypes.bool
};

export default withRouter(PageWrapper);
